module.exports = __webpack_public_path__ + "img/worksbot_img20022506.41e5fa1d.jpg";